export default "__VITE_ASSET__ex35TCBY__"